import { useMemo } from 'react';
import { useTPAComponentsContext } from 'wix-ui-tpa/cssVars';
import { createFormView, } from '@wix/form-fields';
export const useFormView = (form, stepId, styleParams, breakpoint) => {
    const { mobile: isMobile } = useTPAComponentsContext();
    return useMemo(() => {
        return (form?.steps || [])
            .filter((step) => !stepId || stepId === step.id)
            .map((step) => {
            return createFormView({
                form,
                styleParams,
                stepId: step.id,
                isMobile,
                breakpoint,
            });
        });
    }, [form, stepId, isMobile, styleParams, breakpoint]);
};
//# sourceMappingURL=use-form-view.js.map